import { isObject, isString } from "@videojs/utils/predicate";
//#region src/player-api.ts
/** Embed origin: where the embed is served from and where commands are posted. */
const TWITCH_PLAYER_ORIGIN = "https://player.twitch.tv";
/** Namespace on the commands the host posts, and on the state snapshots that come back. */
const PLAYER_PROXY_NAMESPACE = "twitch-embed-player-proxy";
/** Namespace on the lifecycle events the embed emits. */
const EMBED_NAMESPACE = "twitch-embed";
const PLAYBACK_BUFFERING = "Buffering";
const PLAYBACK_PLAYING = "Playing";
const PLAYBACK_ENDED = "Ended";
/** Narrow a `message` payload to something the embed sent; any page can post here, so the namespace is the filter. */
function isTwitchMessage(data) {
	if (!isObject(data)) return false;
	const { namespace, eventName } = data;
	return isString(eventName) && (namespace === "twitch-embed" || namespace === "twitch-embed-player-proxy");
}
//#endregion
export { EMBED_NAMESPACE, PLAYBACK_BUFFERING, PLAYBACK_ENDED, PLAYBACK_PLAYING, PLAYER_PROXY_NAMESPACE, TWITCH_PLAYER_ORIGIN, isTwitchMessage };
